import Model from '../model';
import moment from 'moment';

import Collection from '../collection';
import SessionDataModel from './session-data';
import { SESSION_FLAG_TYPE } from 'data/session';
import { ISession } from 'types/session';

const CHART_SERIES = ['pressure', 'gps', 'rssi'];
export default class SessionModel extends Model<ISession> {
  sessionData: Collection<SessionDataModel> = new Collection({
    path: 'data',
    type: SessionDataModel,
    parent: this
  });

  flags: Collection = new Collection({
    path: 'flag',
    parent: this
  });

  creator: String;
  created: Number;
  updated: Number;
  duration: Number;
  videoId: String;
  videoStart: Number = 0;
  isLive: Boolean;
  stats: { [String]: any } = {};

  chartFlags: Array = [];
  chartSeries: Array = [];

  //   assign() {
  //     const { updated, created, data, creator, videoId, videoStart } = this.snapshot.data();
  //     this.creator = creator;
  //     this.updated = updated;
  //     this.created = created;
  //     this.duration = updated - created;
  //     this.videoId = videoId;
  //     this.videoStart = videoStart;
  //     this.isLive = this.duration < LIVE_TIMEOUT;
  //     this.stats = data || {};

  //     this.updateFlags();
  //   }

  handleDataUpdate = data => {
    if (CHART_SERIES.indexOf(data.key) !== -1) {
      const series = [];
      for (let key of CHART_SERIES) {
        series.push({
          id: key,
          data: this.sessionData.get(key).full
        });
      }

      this.chartSeries = series;
    }
  };

  handleFlagUpdate = (col: Collection) => {
    const data = col.listData();
    const videoStartFlag = data.find(f => f.type === SESSION_FLAG_TYPE.videoStart);
    if (videoStartFlag) {
      this.videoStart = parseInt(videoStartFlag.key);
    }

    this.chartFlags = data.map(m => ({
      x: parseInt(m.key),
      title: 'Video start',
      text: 'This is the video start'
    }));

    this.updateFlags();
  };

  updateFlags() {
    if (this.videoStart) {
      this.chartFlags = this.chartFlags.concat([
        {
          x: this.videoStart,
          title: 'Video Start',
          text: moment(this.videoStart).format('hh:mm:ss')
        }
      ]);
    }
  }

  // unwatch() {
  //   super.unwatch();
  //   this.data.unwatch();
  // }

  watchData(): this {
    this.flags.watch().onUpdate(this.handleFlagUpdate);
    this.sessionData.watch().onChildUpdate(this.handleDataUpdate);
    return this;
  }
}
